<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
  @if (!isCheckData) {
    <div class="mt-6 mb-3">
      <h1 class="text-primary">Continúa actualizando tus datos...</h1>
    </div>
  }

  @if (!isLightVersion()) {
    <div class="w-full space-y-3">
      <app-selected
          class="w-full block"
          [config]="dataSelected().at(0)"
          (selectValue)="handleValue($event)"
      ></app-selected>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['asotip'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getAsotipLabel(dataLastOnboarding['asotip']) }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  @if (!isLightVersion()) {
    <div class="w-full space-y-3">
      @switch (asotipId()) {
        @case (1) {
          <app-independent class="w-full block"
            [defaultData]="defaultData()"
            [isCheckData]="isCheckData"
            [dataLastOnboarding]="dataLastOnboarding"
            [isLightVersion]="isLightVersion()"
            [resetTimer]="resetTimer()"
            (formSubmit)="handleEvent($event)">
          </app-independent>
        }
        @case (2) {
          <app-associated class="w-full block"
            [defaultData]="defaultData()"
            [isCheckData]="isCheckData"
            [dataLastOnboarding]="dataLastOnboarding"
            [isLightVersion]="isLightVersion()"
            [resetTimer]="resetTimer()"
            (formValid)="handleEvent($event)">
          </app-associated>
        }
        @case (3) {
          <app-pensioners class="w-full block"
            [defaultData]="defaultData()"
            [isCheckData]="isCheckData"
            [dataLastOnboarding]="dataLastOnboarding"
            [isLightVersion]="isLightVersion()"
            [resetTimer]="resetTimer()"
            (formValid)="handleEvent($event)">
          </app-pensioners>
        }
        @case (5) {
          <app-agricultural class="w-full block"
            [defaultData]="defaultData()"
            [isCheckData]="isCheckData"
            [dataLastOnboarding]="dataLastOnboarding"
            [isLightVersion]="isLightVersion()"
            [resetTimer]="resetTimer()"
            (formValid)="handleEvent($event)">
          </app-agricultural>
        }
      }
    </div>
  }

  @if (isLightVersion()) {
    <div class="w-full space-y-3">
      <app-input
        class="w-full block"
        [config]="lightVersionIncomeConfig"
        (submitValue)="handleValue($event)"
      ></app-input>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['income'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Ingreso anterior:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding['income'] | number:'1.0-0' }}
            </span>
          </div>
          <span class="text-xs text-label">COP</span>
        </div>
      }
    </div>
  }

  <div class="w-full space-y-3">
    <app-locations class="w-full block m-0"
      (valueState)="setLocation($event)"
      [defaultValue]="defaultData().location"
      [resetTimer]="resetTimer()"
      [showBlocker]="true"
    >
    </app-locations>

    @if (isCheckData && dataLastOnboarding && dataLastOnboarding['locationName'] !== undefined) {
      <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
        <div class="flex items-center gap-2">
          <span class="text-xs text-label">Ubicación anterior:</span>
          <span class="font-medium text-base-content">
            {{ dataLastOnboarding['locationName'] }}
          </span>
        </div>
      </div>
    }
  </div>

  @for (config of lightDataInputs(); track config.formName) {
    <div class="w-full space-y-3">
      <app-input
        class="w-full block"
        [config]="config"
        (submitValue)="handleValue($event)"
      ></app-input>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding[config.formName ?? ''] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding[config.formName ?? ''] }}
            </span>
          </div>
        </div>
      }
    </div>
  }

  <div class="w-full space-y-3">
    <app-selected
      class="w-full block"
      [config]="dataSelected().at(1)"
      (selectValue)="handleValue($event)"
    ></app-selected>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding['zone'] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ getZoneLabel(dataLastOnboarding['zone']) }}
            </span>
          </div>
        </div>
      }
    </div>

  @if (!isLightVersion() && asotipId() === 1) {
    <div class="w-full space-y-3">
      <app-automatic-debit class="w-full block"
          [defaultValue]="defaultData()"
          [isCheckData]="isCheckData"
          [dataLastOnboarding]="dataLastOnboarding"
          (formValueChange)="handleEvent($event)"
      ></app-automatic-debit>
    </div>
  }

  @if (!isCheckData) {
    <button type="submit" class="btn-primary mb-6" [disabled]="!isValidData() || isValidAddress()">
      Continuar
    </button>
  }
</form>

@if (isValidAddress() && !isCheckData) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 md:hidden">
    <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>

    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md animate-scale-in overflow-hidden">
      <div class="p-6 text-center">
        <h2 class="text-2xl font-bold text-blue-800 mb-4">Revisa tu dirección</h2>

        <div class="my-5 flex justify-center">
          <div class="w-52 h-52 bg-blue-100 rounded-full flex items-center justify-center">
            <img src="svg/not-found-address.svg" alt="Validación de dirección">
          </div>
        </div>
        <div class="flex flex-col space-y-3">

        <button type="button" class="btn-primary !bg-[#003085] min-h-12 mb-3" (click)="backValidateAddress(); $event.stopPropagation()">
            CORREGIR DIRECCIÓN
        </button>
        <hr>
        <div class="flex justify-center items-center text-center pt-2">
          <label for="address" class="text-sm font-semibold"> Has ingresado la dirección: <b>{{ form.get('address')?.value }}</b> </label>
        </div>
        <div class="flex items-start">
          <div class="flex items-center h-5">
            <input id="address-validation" type="checkbox"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                  (change)="onCheckboxChange($event)">
          </div>
          <label for="address-validation" class="ms-2 text-sm text-gray-700 text-left">
            La dirección es Correcta
          </label>
        </div>

          <button type="button" class="btn-secundary"
                  (click)="validateAddress(); $event.preventDefault(); $event.stopPropagation()"
                  [disabled]="!isChecked">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Modal Wow (solo en modo no-check) -->
@if (showWowSignal() && !isCheckData) {
  <app-wow (completed)="hideWow()"></app-wow>
}
